<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
            <div>
                <v-row justify="center" >
                    <v-col class="text-left col-md-8">
                        <div class="font-weight-bold body-1">
                            Resultados de la encuesta
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center" class="my-0">
                    <v-col cols="12" md="8" class="py-0">
                        <div class="survey-results-top-buttons">
                            <p class="pb-0 mb-0">
                                A continuación se muestran de forma gráfica los resultados de X respuestas enviadas para
                                esta encuesta
                            </p>
                            <div class="pl-4 survey-results-top-buttons-container">
                                <iconButton :props="downloadBtnData" class="mr-2"></iconButton>
                                <iconButton :props="backBtnData"></iconButton>
                            </div>

                        </div>
                        
                    </v-col>
                
                </v-row>

                 
               
                <v-row justify="center" class=""   v-for="(answer, index) in answers" :key="index">
                    <v-col cols="12" md="8" class="">
                        <v-card
                        class="px-2 py-2"
                        outlined
                       
                        >
                            <span class="font-weight-bold">{{answer.title}}</span> <br>
                            <span class="font-weight-bold grey--text">{{answer.subtitle}}</span> <br> <br>
                            <!-- COMPONENT -->

                            <!-- IMAGES -->
                            <div v-if="answer.type == 'upload_image'">
                                <images-result 
                                    :items="answer.answer.data"
                                />

                            </div>

                            <!-- number -->
                            <div v-if="answer.type == 'number'">
                                <date-time-result
                                    v-for="(numberItem, numberIndex) in answer.answer.data" :key="numberIndex"
                                    :leftText="numberItem.leftText"
                                    :items="numberItem.items"
                                    minWidth="80"
                                />
                            </div>

                            <!-- OPEN -->
                            <div v-if="answer.type == 'open'">
                                <text-result 
                                    :items="answer.answer.data"
                                />
                            </div>

                            <!-- TIME -->
                            <div v-if="answer.type == 'time'">
                                <date-time-result
                                    v-for="(time, timeIndex) in answer.answer.data" :key="timeIndex"
                                    :leftText="time.leftText"
                                    :items="time.items"
                                    minWidth="70"
                                />
                            </div>
                            

                            <!-- DATE -->
                            <div v-if="answer.type == 'date'">
                                <date-time-result
                                    v-for="(date, dateIndex) in answer.answer.data" :key="dateIndex"
                                    :leftText="date.leftText"
                                    :items="date.items"
                                    minWidth="130"
                                />
                            </div>

                             <!-- SCALE -->
                            <div v-if="answer.type == 'scale'">
                                <bar-graph
                                    ref="graph1"
                                    :chartDataInput="answer.answer.data"
                                    data-cy="graph-1"
                                    :firstLabel="answer.answer.startLabel"
                                    :lastLabel="answer.answer.endLabel"
                                />
                            </div>

                            <!-- BINARY -->
                            <div v-if="answer.type == 'binary'">
                                <bar-vertical 
                                    ref="graph2"
                                    :chartDataInput="answer.answer.data"
                                    data-cy="graph-2"
                                />
                            </div>

                            <!-- MULTI -->
                            <div v-if="answer.type == 'multi'">
                                <bar-vertical 
                                    ref="graph3"
                                    :chartDataInput="answer.answer.data"
                                    data-cy="graph-3"
                                />
                            </div>

                          
                        </v-card>
                        
                    </v-col>
                
                </v-row>

            </div>

           
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../../../helpers/Utils';
import BarHorizontal from './BarHorizontal.vue';
import BarVertical from './BarVertical.vue';
import DateTimeResultVue from './DateTimeResult.vue';
import ImagesResultVue from './ImagesResult.vue';
import TextResultVue from './TextResult.vue';

export default {
    components: {
        'bar-graph': BarHorizontal,
        'bar-vertical': BarVertical,
        'date-time-result': DateTimeResultVue,
        'text-result': TextResultVue,
        'images-result': ImagesResultVue,
    },
    
	data(){
		return {
            id: this.$route.params.id,
            loading:true,



            colors: [
                "#2C4F6E",
                "#657D91",
                "#F6AB80",
                "#F16400",
                "#ABA393",
                "#F5BF7F",
                "#F5E4D1",
                "#F0987D",
                "#5147A8",
                "#5174F2",
                "#F22E00",
                "#E1F720",
            ],
            answers: [
                // {
                //     title: "",
                //     subtitle: "",
                //     type: "",
                //     answer:{}
                // }
            ],

            barHorizontalDataTemplate:{
                labels:[
                    'RESPUESTAS',
                ],
                datasets:[
                    {
                        label: '21 (22%)', //quotations
                        backgroundColor: '#2C4F6E',
                        data: [22],
                        datalabels: {
                            color: '#FFFFFF'
                        }
                    },
                    {
                        label: '48 (50%)', //quotations
                        backgroundColor: '#657D91',
                        data: [50],
                        datalabels: {
                            color: '#FFFFFF'
                        }
                    },
                    {
                        label: '14 (15%)', //quotations
                        backgroundColor: '#C4CBCF',
                        data: [15],
                        datalabels: {
                            color: '#000000'
                        }
                    },
                    {
                        label: '9 (9%)', //quotations
                        backgroundColor: '#F6AB80',
                        data: [9],
                        datalabels: {
                            color: '#000000'
                        }
                    },
                    {
                        label: '4 (4%)', //quotations
                        backgroundColor: '#F16400',
                        data: [4],
                        datalabels: {
                            color: '#000000'
                        }
                    }
                   
                ]
            },

            // barVerticalTemplate: {
            //     labels: ['PROSPECCIÓN', 'FACTURACIÓN', 'INSUMOS'],
            //     datasets:[
            //         {
                        
            //             label: 'PROSPECCIÓN',
            //             backgroundColor: [],
            //             data: [1, 0, 0]
            //         },
            //         {
                        
            //             label: 'FACTURACIÓN',
            //             backgroundColor: '#3D5B96',
            //             data: [0, 2, 0]
            //         },
            //         {
                        
            //             label: 'INSUMOS',
            //             backgroundColor: '#3D5B96',
            //             data: [0, 0, 3]
            //         },
                   
            //     ],
                
            // },
            barVerticalTemplate: {
                labels: [], //'PROSPECCIÓN', 'FACTURACIÓN', 'INSUMOS'
                datasets:[
                    // {
                        
                    //     label: 'PROSPECCIÓN',
                    //     backgroundColor: [],
                    //     data: [1, 0, 0]
                    // },
                    // {
                        
                    //     label: 'FACTURACIÓN',
                    //     backgroundColor: '#3D5B96',
                    //     data: [0, 2, 0]
                    // },
                    // {
                        
                    //     label: 'INSUMOS',
                    //     backgroundColor: '#3D5B96',
                    //     data: [0, 0, 3]
                    // },
                   
                ],
                
            },

            downloadBtnData: {
				hasTooltip:true,
                tooltip: 'Exportar',
                color:'primary',
                height:'35',
                text: "",
                icon: "mdi-progress-download",
				to: "",
				block: true,
                loading:false,
                click: ()=>{this.export()}
            },
            backBtnData: {
				hasTooltip:true,
                tooltip: 'Atrás',
                color:'primary',
                height:'35',
                text: "",
                icon: "mdi-arrow-left",
				to: "Questionary",
				block: true,
                click: ()=>{}
            }
		}
    },
    watch: {
        step: function(){
            this.saveBtnData.text = "Continuar";
            if(this.step == 2)
                this.saveBtnData.text = "Guardar cambios";
        }
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        this.index();
    },
	methods: {
        onResize () {
            
           
        },

        index()
        {
            this.loading = true;
            this.$api.questionaries.results(this.id)
				.then((resp) =>{
					//process
                    resp.data.forEach((item,index )=> {
                        item.title = `${index + 1}.- ${item.title}`;
                        if(item.type == "scale"){
                           this.answers.push( this.processScale(item));
                        }
                        if(item.type == "binary"){
                           this.answers.push( this.processBinary(item));
                        }
                        if(item.type == "multi"){
                           this.answers.push( this.processMulti(item));
                        }
                        if(item.type == "time"){
                           this.answers.push( this.processTime(item));
                        }
                        if(item.type == "date"){
                           this.answers.push( this.processDate(item));
                        }
                        if(item.type == 'open'){
                            this.answers.push(this.processOpenText(item));
                        }
                        if(item.type == 'number'){
                            this.answers.push(this.processNumber(item));
                        }
                        if(item.type == 'upload_image'){
                            this.answers.push(this.processImages(item));
                        }
                    });
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
                    this.loading = false
				})
			;
        },
        processImages(data){
            let ans = {
                title: data.title,
                subtitle: '',
                type: data.type,
                answer:{
                    data: []
                }
            };
            let totalAnswers = 0;
            for (let i = 0; i < data.raw.length; i++) {
                const element = data.raw[i];
                totalAnswers = totalAnswers + 1;
                ans.answer.data.push(...element.answer_value);
            }
            ans.answer.data = ans.answer.data.map((x) => {
                return {url: x};
            })
            ans.subtitle = `${totalAnswers} RESPUESTAS`;
            return ans;
        },
        processNumber(data){
            let ans = {
                title: data.title,
                subtitle: '',
                type: data.type,
                answer:{
                    data: []
                }
            };
            

            
            let totalAnswers = 0;
            for (let i = 0; i < data.data.length; i++) {
                const element = data.data[i];
                totalAnswers = totalAnswers + element.total;
                const range = Utils.getUnitType(element.label).toString();
                // console.log(range, Utils.getUnitType("-20"));
                let found = ans.answer.data.findIndex((x) => x.unitType == range);
                // console.log(found, "found")
                if(found >= 0){
                    ans.answer.data[found].items.push(
                        {
                            text: element.label,
                            count: element.total,
                            active: element.total > 1 ? true : false,
                        },
                    )
                }else{
                    ans.answer.data.push({
                        leftText: range,
                        unitType: range,
                        items:[
                            {
                                text: element.label,
                                count: element.total,
                                active: element.total > 1 ? true : false,
                            }
                        ]
                    })
                }
                
            }

            ans.subtitle = `${totalAnswers} RESPUESTAS`;

            return ans;
        },
        processOpenText(data){
            let ans = {
                title: data.title,
                subtitle: `${data?.raw?.length} RESPUESTAS`,
                type: data.type,
                answer:{
                    data: data?.raw?.map((x) => {
                        return {text: x.answer_value};
                    }),
                }
            };
            return ans;
        },
        processDate(data){
            // let info = JSON.parse(JSON.stringify(this.barVerticalTemplate));
            let ans = {
                title: data.title,
                subtitle: "",
                type: data.type,
                answer:{
                    data: [],
                }
            };
            let order = data.data.sort(function (a, b) {
                if (a.label > b.label) {
                    return 1;
                }
                if (a.label < b.label) {
                    return -1;
                }
                return 0;
            });
            let totalAnswers = 0;
            for (let i = 0; i < order.length; i++) {
                const element = order[i];
                totalAnswers = totalAnswers + element.total;
                const date = `${element.label.split("-")[0]}-${element.label.split("-")[1]}`;
                let found = ans.answer.data.findIndex((x) => x.halfDate == date);
                // console.log(found, "found")
                if(found >= 0){
                    ans.answer.data[found].items.push(
                        {
                            text: element.label.split("-")[2],
                            count: element.total,
                            active: element.total > 1 ? true : false,
                        },
                    )
                }else{
                    ans.answer.data.push({
                        leftText: Utils.getMonthYearString(element.label),
                        halfDate: date,
                        items:[
                            {
                                text: element.label.split("-")[2],
                                count: element.total,
                                active: element.total > 1 ? true : false,
                            }
                        ]
                    })
                }
                
            }

            ans.subtitle = `${totalAnswers} RESPUESTAS`

            // console.log(ans)
            return ans;
        },
        processTime(data){
            // let info = JSON.parse(JSON.stringify(this.barVerticalTemplate));
            let ans = {
                title: data.title,
                subtitle: "",
                type: data.type,
                answer:{
                    data: [],
                }
            };
            let order = data.data.sort(function (a, b) {
                if (a.label > b.label) {
                    return 1;
                }
                if (a.label < b.label) {
                    return -1;
                }
                return 0;
            });
            let totalAnswers = 0;
            for (let i = 0; i < order.length; i++) {
                const element = order[i];
                totalAnswers = totalAnswers + element.total;
                const hour = `${element.label.split(":")[0]}:00`;
                let found = ans.answer.data.findIndex((x) => x.leftText == hour);
                // console.log(found, "found")
                if(found >= 0){
                    ans.answer.data[found].items.push({
                        text: element.label,
                        count: element.total,
                        active: element.total > 1 ? true : false,
                    })
                }else{
                    ans.answer.data.push({
                        leftText: hour,
                        items:[
                            {
                                text: element.label,
                            count: element.total,
                            active: element.total > 1 ? true : false,
                            }
                        ]
                    })
                }
                
            }

            ans.subtitle = `${totalAnswers} RESPUESTAS`

            // console.log(ans)
            return ans;
        },

        processMulti(data){
            let info = JSON.parse(JSON.stringify(this.barVerticalTemplate));
            let ans = {
                title: data.title,
                subtitle: "",
                type: data.type,
                answer:{
                    
                    data: info,
                }
            }

            let totalAnswers = 0;
            for (let i = 0; i < data.data.length; i++) {
                const element = data.data[i];
                totalAnswers = totalAnswers + element.total;
                // console.log(i % this.colors.length, this.colors[i % this.colors.length])
                ans.answer.data.labels.push(element.label.toUpperCase());
                ans.answer.data.datasets.push(
                    {
                        label: `${element.label.toUpperCase()} (${element.total})`,
                        backgroundColor: this.colors[i%this.colors.length],
                        data: data.data.map((x) => {
                            if(x.label == element.label)
                                return x.total
                            return 0
                        })
                    },
                );
            }
            ans.subtitle = `${totalAnswers} RESPUESTAS`;
            // console.log(ans)
            return ans;


        },

        processBinary(data){
            let info = JSON.parse(JSON.stringify(this.barVerticalTemplate));
            let ans = {
                title: data.title,
                subtitle: "",
                type: data.type,
                answer:{
                    
                    data: info,
                }
            }

            ans.answer.data.labels = ["SI", "NO", "NO APLICA"];
            ans.answer.data.datasets = [
                {
                    label: 'SI',
                    backgroundColor: '#2C4F6E',
                    data: [0, 0, 0]
                },
                {
                    
                    label: 'NO',
                    backgroundColor: '#657D91',
                    data: [0, 0, 0]
                },
                {
                    label: 'NO APLICA',
                    backgroundColor: '#F6AB80',
                    data: [0, 0, 0]
                }
            ]
            
            let totalAnswers = 0;
            for (let i = 0; i < data.data.length; i++) {
                const element = data.data[i];
                totalAnswers = totalAnswers + element.total;
                if(element.label == "true"){
                    ans.answer.data.datasets[0].data = [element.total, 0 , 0]
                }
                if(element.label == "false"){
                    ans.answer.data.datasets[1].data =  [0, element.total, 0]
                }
                if(element.label == "na"){
                    ans.answer.data.datasets[2].data = [0, 0, element.total]
                }
            }
            ans.subtitle = `${totalAnswers} RESPUESTAS`;

            if(data.data.length == 2 || !data.question.add_not_apply){
                ans.answer.data.labels.pop();
                ans.answer.data.datasets.pop();
            }




            return ans;
        },

        processScale(data){
            let info = JSON.parse(JSON.stringify(this.barHorizontalDataTemplate));
            let ans = {
                title: data.title,
                subtitle: "",
                type: data.type,
                answer:{
                    startLabel: data?.question?.end_tag.toUpperCase()??"",
                    endLabel: data?.question?.start_tag.toUpperCase()??"",
                    data: info,
                }
            }
            let totalAnswers = 0;
            for (let i = 0; i < data.data.length; i++) {
                const element = data.data[i];
                totalAnswers = totalAnswers + element.total;
            }
            ans.subtitle = `${totalAnswers} RESPUESTAS`

            for (let i = 0; i < data.data.length; i++) {
                const element = data.data[i];
                const result = ((element.total * 100) / totalAnswers).toFixed(2);

                // // console.log(result, 4-4, 4-3, 4-2, 4-1, 4-0)
                ans.answer.data.datasets[4 - (parseInt(element.label))].data = [result]
                ans.answer.data.datasets[4 - (parseInt(element.label))].label = `${element.total} (${result}%)`
            }
            return ans;

        },

        export()
        {
            this.downloadBtnData.loading = true;
            this.$api.questionaries.exportResults(this.id)
				.then((resp) =>{
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `encuesta_${this.id}.xlsx`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
                    this.downloadBtnData.loading = false;
				})
			;
        }
       
    },
}
</script>

<style lang="scss">
    .survey-results-top-buttons{
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        p{
            align-content: flex-end;
        }
    }

    .survey-results-top-buttons-container{
        display: flex;
    }
</style>